import PropTypes from 'prop-types';
import styles from './SnackBar.module.scss';

const SnackBar = ({ variant, visible, children, prefix, endOfLine, suffix, ...props }) => {
    return <div className={[styles.snackBar, (visible ? styles[variant] : styles.invisible)].join(' ')} {...props}>
        { prefix && <div className={styles.prefix}>
            {prefix}
        </div>}
        <div className={styles.content}>
            <div>
                {children}
            </div>
            { endOfLine && <div className={styles.endOfLine}>
                {endOfLine}
            </div>}
        </div>
        { suffix && <div className={styles.suffix}>
            {suffix}
        </div>}
    </div>;
};

SnackBar.propTypes = {
    visible: PropTypes.bool,
    children: PropTypes.any,
    prefix: PropTypes.any,
    endOfLine: PropTypes.any,
    suffix: PropTypes.any,
    variant: PropTypes.oneOf(['primary', 'secondary', 'error', 'warning', 'success', 'info', 'notice']),
    'data-testid': PropTypes.string
};

SnackBar.defaultProps = {
    visible: true,
    variant: 'primary'
};

export default SnackBar;
